'use client'

import React from 'react'
import { ChevronDown } from 'lucide-react'

interface Props {
    targetId?: string
    text?: string
}

const ShowDetailsBtn = ({ targetId = 'fullDetails', text = 'See Full Details' }: Props) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault()
        const el = document.getElementById(targetId)
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-label="Show store details"
            className="inline-flex items-center gap-2 bg-white hover:bg-slate-50 text-slate-700 hover:text-[#00a87a] font-bold text-xs uppercase tracking-wider px-4 py-2.5 rounded-2xl border border-slate-200 shadow-xs hover:shadow-md transition-all duration-300 cursor-pointer group shrink-0"
        >
            <span>{text}</span>
            <ChevronDown size={14} className="text-slate-400 group-hover:text-[#00a87a] transition-transform duration-300 group-hover:translate-y-0.5" />
        </button>
    )
}

export default ShowDetailsBtn
